// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__jvycw","location":"Header_location__3TLnd"};